export default from './profile-posts';



// WEBPACK FOOTER //
// ./app/containers/profile-posts/index.js